import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import TrialTagFields from '../record/TrialTagFields';
import { SESSION_SCOPE, TRIAL_SCOPE } from '../../util/trialTagFields';
import '../../../dist/assets/stylesheets/css/recordPatient.css';
import '../../../dist/assets/stylesheets/css/patients.css';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'min(720px, 92vw)',
  maxHeight: '85vh',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
};

function EditTrialTagsModal(props) {
  const {
    open,
    onClose,
    sessionTags,
    trialTags,
    onSave,
    suggestions,
    saving,
  } = props;
  const [draftSessionTags, setDraftSessionTags] = useState(sessionTags);
  const [draftTrialTags, setDraftTrialTags] = useState(trialTags);

  useEffect(() => {
    if (!open) return;
    setDraftSessionTags(sessionTags);
    setDraftTrialTags(trialTags);
  }, [open, sessionTags, trialTags]);

  const handleSessionChange = (key, value) => {
    setDraftSessionTags((prev) => ({ ...prev, [key]: value }));
  };

  const handleTrialChange = (key, value) => {
    setDraftTrialTags((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    onSave({ sessionTags: draftSessionTags, trialTags: draftTrialTags });
  };

  return (
    <Modal
      open={open}
      onClose={saving ? undefined : onClose}
      aria-labelledby="edit-trial-tags-title"
      /* CreatableSelect menus portal to document.body; allow focus outside the dialog. */
      disableEnforceFocus
      disableAutoFocus
    >
      <Box sx={modalStyle} className="edit-trial-tags-modal">
        <Typography id="edit-trial-tags-title" variant="h6" component="h2" mb={2}>
          Edit Tags
        </Typography>
        <div className="edit-trial-tags-modal__section">
          <Typography variant="subtitle2" component="h3" className="edit-trial-tags-modal__heading">
            Session
          </Typography>
          <div className="recording-trial__tags">
            <TrialTagFields
              scope={SESSION_SCOPE}
              values={draftSessionTags}
              onChange={handleSessionChange}
              idPrefix="review-session-tag"
              suggestions={suggestions}
              disabled={saving}
            />
          </div>
        </div>
        <div className="edit-trial-tags-modal__section">
          <Typography variant="subtitle2" component="h3" className="edit-trial-tags-modal__heading">
            Trial
          </Typography>
          <div className="recording-trial__tags">
            <TrialTagFields
              scope={TRIAL_SCOPE}
              values={draftTrialTags}
              onChange={handleTrialChange}
              idPrefix="review-trial-tag"
              suggestions={suggestions}
              disabled={saving}
            />
          </div>
        </div>
        <Box display="flex" justifyContent="flex-end" gap={1.5} mt={3}>
          <Button variant="outlined" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving…' : 'Save'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default EditTrialTagsModal;
